import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input
} from "reactstrap";

import {connect} from "react-redux";
import ReactMultiSelect from "./MultiSelect";
import {getFinancicalSchemas, getAllProjects,setDealroom,saveName} from "../../../store/actions";

class AddModal extends React.Component {
  state = {
    modal: false,
    errors: {},
    projects_ids: [],
    fin_strs_ids: [],
    name: '',
  };

  componentDidMount() {
    const {getFinancicalSchemas, getAllProjects} = this.props;
    getFinancicalSchemas();
    getAllProjects();
  }

  handleSelect = (value, mode,key) => {
    let myvalue = value.id;

    let multivalue = [];
    if (mode === "multi") {
      value.map(data => {
        multivalue.push(data.id);
        return data;
      });
      if(value.length === 0){
        this.setState({[key]: multivalue,errors:{...this.state.errors,[key]:'Field is requierd'}});
      } else {
        this.setState({[key]: multivalue,errors:{...this.state.errors,[key]:''}});
      }

    } else {
      this.setState({[key]: myvalue});
    }
  };

  handleChange = event => {
    if(event.target.value){
      this.setState({name: event.target.value});
    }else {
      this.setState({name: event.target.value,errors:{...this.state.errors,name:'Field is requierd'}});
    }
  };

  handleClick = () => {
    const {name,projects_ids,
      fin_strs_ids,errors} = this.state;
    const {history,saveName,setDealroom} = this.props;

      let flag = false;
      let err = errors;
      if(!name){
        flag = true;
        err.name = "Field is requierd";
      } else {
        err.name = "";
      }
      if(fin_strs_ids.length === 0){
        flag = true;
        err.fin_strs_ids = "Field is requierd";
      } else {
        err.fin_strs_ids = "";
      }
      if(projects_ids.length === 0){
        flag = true;
        err.projects_ids = "Field is requierd";
      }else {
        err.projects_ids = "";
      }
      this.setState({errors:err});
      if(!flag){
        saveName(name);
        setDealroom({name,projects:projects_ids,financial_structures:fin_strs_ids})
          .then(res => {
            history.push({
              pathname: "/dealroom-view/" + res.id,
              state: { name }
            });

          })

      }


  };

  render() {
    const {dealroomProjects, dealroomfinancicalSchemas, isOpen, className, toggle} = this.props;
    const {name,errors} = this.state;

    return (
      <div>
        <Modal
          isOpen={isOpen}
          toggle={this.toggle}
          className={className}
        >
          <ModalHeader toggle={this.toggle}>Add new dealroom</ModalHeader>
          <ModalBody>
            <CardBody>
              <Row>
                <Col xs="8">
                  <FormGroup onSubmit={() => {
                  }}>
                    <Label htmlFor="name">Set a name</Label>
                    <Input
                      type="text"
                      id="name"
                      value={name}
                      placeholder="Enter your name"
                      onChange={this.handleChange}
                      required
                    />
                    {errors.name && <p style={{color:'red'}}>{errors.name}</p>}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="8">
                  <FormGroup>
                    <Label htmlFor="name">Select Projects</Label>{" "}
                    <ReactMultiSelect
                      optionsData={dealroomProjects}
                      handleSelect={this.handleSelect}
                      state_key={"projects_ids"}
                    />
                    {errors.projects_ids && <p style={{color:'red'}}>{errors.projects_ids}</p>}

                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="8">
                  <FormGroup>
                    <Label htmlFor="name">Select Financial Structures</Label>{" "}
                    <ReactMultiSelect
                      optionsData={dealroomfinancicalSchemas}
                      handleSelect={this.handleSelect}
                      state_key={"fin_strs_ids"}
                    />
                    {errors.fin_strs_ids && <p style={{color:'red'}}>{errors.fin_strs_ids}</p>}
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </ModalBody>

          <ModalFooter>
            <Button color="primary" onClick={this.handleClick}>
              Add
            </Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dealroomProjects: state.dealroom.dealroomProjects,
    dealroomfinancicalSchemas: state.financicalSchemas.res && state.financicalSchemas.res.results,
  }
};

export default connect(
  mapStateToProps,
  {getAllProjects, getFinancicalSchemas,setDealroom,saveName}
)(AddModal);




// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/Modal.js